import {
  STORES_REQUEST, STORES_SUCCESS,
  STORES_STATUS_REQUEST, STORES_STATUS_SUCCESS,
  STORES_ALL_REQUEST, STORES_ALL_SUCCESS
} from '../constants/actionTypes';

const initialState = {
  data: {
    errors: [],
    page: 0,
    pageSize: 50,
    rows: [],
    totalPages: 0
  },
  allStores: [],
  searchKeyword: '',
  allStoresSearchKeyword: '',
  loading: false,
  statusUpdateSuccess: false
};

export default function stores(state = initialState, action) {
  switch (action.type) {
    case STORES_REQUEST:
      return {
        ...state,
        loading: true,
        statusUpdateSuccess: false
      };
    case STORES_ALL_REQUEST:
      return {
        ...state,
        allStoresSearchKeyword: action.searchKeyword
      };
    case STORES_STATUS_REQUEST:
      return {
        ...state,
        loading: false,
        statusUpdateSuccess: false
      };
    case STORES_SUCCESS:
      return {
        ...state,
        data: action.data,
        loading: false,
        statusUpdateSuccess: false
      };
    case STORES_ALL_SUCCESS:
      return {
        ...state,
        allStores: action.data
      };
    case STORES_STATUS_SUCCESS:
      return {
        ...state,
        statusUpdateSuccess: true
      };
    default:
      return state;
  }
}
